import React from 'react'
import {Input, Icon} from 'antd'

import InputDecorator from './InputDecorator'

const InputDecorated = ({fieldName, rules, initialValue, placeholder, suffix, icon, disabled, password, style}) => {
  const InputElement = password ? Input.Password : Input

  return (
    <InputDecorator fieldName={fieldName} initialValue={initialValue} rules={rules}>
      <InputElement
        style={style}
        disabled={disabled}
        placeholder={placeholder}
        prefix={icon && <Icon type={icon}/>}
        suffix={suffix}
      />
    </InputDecorator>
  )
}

export default InputDecorated
